import fetchLoyaltyAccountPendingPoints from 'actions/loyalty/fetchLoyaltyAccountPendingPoints'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { sum } from 'lib/array/arrayUtils'
import { useEffect, useMemo } from 'react'

function useCurrentLoyaltyPendingPoints(): [{ points: number, statusCredits: number, items: Array<App.LoyaltyAccountPendingPoints> }, boolean, any] {
  const points = useAppSelector(state => state.loyalty.accountPendingPoints)
  const dispatch = useAppDispatch()

  const pointsDetails = useMemo(() => ({
    points: sum(points.data ?? [], point => point.points),
    statusCredits: sum(points.data ?? [], point => point.statusCredits),
    items: points.data ?? [],
  }), [points.data])

  useEffect(() => {
    dispatch(fetchLoyaltyAccountPendingPoints())
  }, [dispatch])

  return [
    pointsDetails,
    !!points?.fetching,
    points.error,
  ]
}

export default useCurrentLoyaltyPendingPoints
